import { APP_COLORS } from 'src/shared/entities';

import type { IAppColor } from 'src/shared/entities';

const hashString = (value: string): number => {
  let hash = 0;

  for (let i = 0; i < value.length; i++) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }

  return Math.abs(hash);
};

export const getAvatarColor = (seed: string): IAppColor => {
  const index = hashString(seed) % APP_COLORS.length;
  return APP_COLORS[index].value;
};

export const getInitials = (name: string): string => {
  const [first, second] = name.trim().split(/\s+/);
  return second ? `${first[0]}${second[0]}`.toUpperCase() : first.slice(0, 2).toUpperCase();
};

// Tailwind needs the full class name statically in source, so this looks the
// className up from the palette rather than interpolating `bg-${color}`.
export const getAvatarColorClassName = (color: IAppColor): string =>
  APP_COLORS.find(({ value }) => value === color)!.className;
